
<template>
  <div id="shot_query" class="border-padding">
  <main>
    <div class="row">
      <div class="col-md-3" v-if="season_dropdown.data != undefined">
        <season-select v-model="seasons_selected" :options="season_dropdown"></season-select>
      </div>

      <div class="col-md-2" v-if="season_type_dropdown.data != undefined">
        <season-type-select v-model="season_type_selected" :options="season_type_dropdown"></season-type-select>
      </div>

      <div class="col-md-2" v-if="stat_type_dropdown.data != undefined">
        <label class="typo__label">{{stat_type_dropdown.label}}</label>
        <multiselect
          v-model="stat_type_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          placeholder=""
          :options="stat_type_dropdown.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>

      <div class="col-md-2" v-if="possession_start_dropdown.data != undefined && stat_type_selected && stat_type_selected.id != 'KobeAssist'">
        <possession-start-select v-model="possession_start_selected" :options="possession_start_dropdown"></possession-start-select>
      </div>
    </div>

    <div v-if="stat_type_selected && stat_type_selected.id != 'KobeAssist'" class="border-padding">
      Period:
      From: <input v-model="period_gte" placeholder="" maxlength="1" size="2">
      To: <input v-model="period_lte" placeholder="" maxlength="1" size="2">
    </div>

    <div v-if="stat_type_selected && stat_type_selected.id != 'KobeAssist'" class="border-padding">
      Shot Time (optional):
      From: <input v-model="shot_time_lte" placeholder="" maxlength="3" size="3">
      To: <input v-model="shot_time_gte" placeholder="" maxlength="3" size="3">
      (Enter time remaining in period in seconds. Ex. For last 2 minutes enter From 120 To 0)
    </div>

    <div v-if="stat_type_selected && stat_type_selected.id != 'KobeAssist'" class="border-padding">
      Possession Start Time (optional):
      From: <input v-model="possession_start_time_from" placeholder="" maxlength="3" size="3">
      To: <input v-model="possession_start_time_to" placeholder="" maxlength="3" size="3">
      (Enter time remaining in period in seconds. Ex. For last 2 minutes enter From 120 To 0)
    </div>

    <div v-if="stat_type_selected && stat_type_selected.id != 'KobeAssist'" class="border-padding">
      Score Margin (optional):
      From: <input v-model="margin_from" placeholder="" maxlength="3" size="3">
      To: <input v-model="margin_to" placeholder="" maxlength="3" size="3">
      (Example: From -3 to -1 will get all possessions when the team was down by 3 points or less)
    </div>

    <div v-if="stat_type_selected && stat_type_selected.id != 'KobeAssist'" class="border-padding">
      Shot Distance (feet) (optional):
      From: <input v-model="shot_distance_gte" placeholder="" maxlength="2" size="2">
      To: <input v-model="shot_distance_lte" placeholder="" maxlength="2" size="2">
    </div>

    <div v-if="stat_type_selected && stat_type_selected.id != 'KobeAssist'" class="border-padding">
      Seconds Since Possession Start (optional):
      From: <input v-model="seconds_since_possession_start_gte" placeholder="" maxlength="2" size="2">
      To: <input v-model="seconds_since_possession_start_lte" placeholder="" maxlength="2" size="2">
    </div>

    <div class="col-md-4" v-if="oreb_missed_shot_type_dropdown.data != undefined">
        <label class="typo__label">{{oreb_missed_shot_type_dropdown.label}} (optional)</label>
        <multiselect
          v-model="oreb_missed_shot_type_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="false"
          placeholder=""
          :options="oreb_missed_shot_type_dropdown.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="true">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>

    <div class="border-padding">
      Seconds Since Offensive Rebound(optional):
      From: <input v-model="seconds_since_oreb_gte" placeholder="" maxlength="2" size="2">
      To: <input v-model="seconds_since_oreb_lte" placeholder="" maxlength="2" size="2">
    </div>

    <div v-if="stat_type_selected && stat_type_selected.id == 'Player'" class="border-padding">
      <input v-model="off_own_dreb" type="checkbox"> Off Own Defensive Rebound
      <input v-model="off_own_oreb" type="checkbox"> Off Own Offensive Rebound
      <input v-model="off_own_miss" type="checkbox"> Off Own Miss
    </div>

    <div class="border-padding">
      <button class="" v-on:click="changeStats()">Get Summary</button>
    </div>
    <div v-if="stat_type_selected && stat_type_selected.id == 'KobeAssist'" class="border-padding">
      <p>Kobe assist numbers are stats for shots following a live ball offensive rebound off a missed FG by the listed player</p>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <div v-if="table_data.length > 0">
        <vue-good-table
            :columns="table_columns"
            :rows="table_data"
            :pagination-options="{ enabled: true, perPage: 30}"
            :searchOptions="{ enabled: false}"
            :sort-options="{ enabled: true, initialSortBy: {field: 'name', type: 'asc'}}"
            styleClass="vgt-table bordered striped">
            <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field != 'name'">
                <span>
                  {{props.formattedRow[props.column.field]}}
                </span>
              </div>
              <div v-else>
                <span>
                  <b>{{props.formattedRow[props.column.field]}}</b>
                </span>
              </div>
            </template>
            <template slot="table-column" slot-scope="props">
            <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
                {{props.column.label}}
            </span>
            <span v-else>
                {{props.column.label}}
            </span>
            </template>
        </vue-good-table>
    </div>

  </main>
  </div>
</template>

<script>
import axios from 'axios'
import GetDropdownOptions from './mixins/get_dropdown'
import Multiselect from 'vue-multiselect'
import { tableUtils } from './mixins/table_utils'
import SeasonTypeSelect from './mixins/SeasonTypeSelect.vue'
import SeasonSelect from './mixins/SeasonSelect.vue'
import PossessionStartSelect from './mixins/PossessionStartSelect.vue'
import { season, seasonType, orebShotType, startType } from './mixins/dropdowns'

export default {
  name: 'ShotQuerySummary',
  components: {
    Multiselect,
    SeasonTypeSelect,
    SeasonSelect,
    PossessionStartSelect
  },
  mixins: [tableUtils, SeasonTypeSelect, SeasonSelect, PossessionStartSelect, GetDropdownOptions, season, seasonType, orebShotType, startType],
  data () {
    return {
      loading: false,
      season_dropdown: {},
      seasons_selected: [],
      season_type_dropdown: {},
      season_type_selected: undefined,
      possession_start_dropdown: {},
      possession_start_selected: undefined,
      stat_type_dropdown: {},
      stat_type_selected: undefined,
      oreb_missed_shot_type_dropdown: {},
      oreb_missed_shot_type_selected: undefined,
      margin_from: undefined,
      margin_to: undefined,
      period_lte: undefined,
      period_gte: undefined,
      shot_time_lte: undefined,
      shot_time_gte: undefined,
      shot_distance_lte: undefined,
      shot_distance_gte: undefined,
      seconds_since_possession_start_lte: undefined,
      seconds_since_possession_start_gte: undefined,
      seconds_since_oreb_lte: undefined,
      seconds_since_oreb_gte: undefined,
      possession_start_time_from: undefined,
      possession_start_time_to: undefined,
      off_own_dreb: false,
      off_own_oreb: false,
      off_own_miss: false,
      use_min_filters: false,
      use_text_filters: false,
      show_error_message: false,
      table_columns: [
        {'field': 'name', 'label': 'Name'},
        {'field': 'fga', 'label': 'FGA', 'type': 'number'},
        {'field': 'efg', 'label': 'eFG%', 'type': 'percentage'},
        {'field': 'fg2m', 'label': 'FG2M', 'type': 'number'},
        {'field': 'fg2a', 'label': 'FG2A', 'type': 'number'},
        {'field': 'fg2pct', 'label': 'FG2%', 'type': 'percentage'},
        {'field': 'afg2m', 'label': 'Assisted FG2M', 'type': 'number'},
        {'field': 'fg3m', 'label': 'FG3M', 'type': 'number'},
        {'field': 'fg3a', 'label': 'FG3A', 'type': 'number'},
        {'field': 'fg3pct', 'label': 'FG3%', 'type': 'percentage'},
        {'field': 'afg3m', 'label': 'Assisted FG3M', 'type': 'number'},
        {'field': 'putback_fgm', 'label': 'Putback FGM', 'type': 'number'},
        {'field': 'putback_fga', 'label': 'Putback FGA', 'type': 'number'},
        {'field': 'putback_fg_pct', 'label': 'Putback FG%', 'type': 'percentage'},
        {'field': 'rim_fgm', 'label': ' Rim FGM', 'type': 'number'},
        {'field': 'rim_fga', 'label': ' Rim FGA', 'type': 'number'},
        {'field': 'rim_fg_pct', 'label': ' Rim FG%', 'type': 'percentage'},
        {'field': 'smr_fgm', 'label': 'SMR FGM', 'type': 'number'},
        {'field': 'smr_fga', 'label': 'SMR FGA', 'type': 'number'},
        {'field': 'smr_fg_pct', 'label': 'SMR FG%', 'type': 'percentage'},
        {'field': 'lmr_fgm', 'label': 'LMR FGM', 'type': 'number'},
        {'field': 'lmr_fga', 'label': 'LMR FGA', 'type': 'number'},
        {'field': 'lmr_fg_pct', 'label': 'LMR FG%', 'type': 'percentage'},
        {'field': 'c3_fgm', 'label': 'C3 FGM', 'type': 'number'},
        {'field': 'c3_fga', 'label': 'C3 FGA', 'type': 'number'},
        {'field': 'c3_fg_pct', 'label': 'C3 FG%', 'type': 'percentage'},
        {'field': 'ab3_fgm', 'label': 'AB3 FGM', 'type': 'number'},
        {'field': 'ab3_fga', 'label': 'AB3 FGA', 'type': 'number'},
        {'field': 'ab3_fg_pct', 'label': 'AB3 FG%', 'type': 'percentage'}
      ],
      table_data: [],
      direct_link: '',
      api_endpoint: 'get-shot-query-summary/'
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData',
    '$parent.league': 'changeLeague'
  },
  methods: {
    changeLeague () {
      this.table_data = []
      this.seasons_selected = []
      this.$router.push({name: 'shot_query_summary', params: {league: this.$parent.league}})
    },
    setDropdown () {
      this.possession_start_dropdown = this.start_type_dropdown_options
      this.stat_type_dropdown = {
        'label': 'Stat Type',
        'data': [
          {'id': 'Team', 'text': 'Team'},
          {'id': 'Opponent', 'text': 'Opponent'},
          {'id': 'Player', 'text': 'Player'},
          {'id': 'KobeAssist', 'text': 'Kobe Assists'}
        ]
      }
      this.oreb_missed_shot_type_dropdown = this.oreb_shot_type_dropdown_options

      this.setPossessionStartType()

      this.stat_type_selected = this.stat_type_dropdown.data[0]
      this.stat_type_dropdown.data.forEach((statType) => {
        if (statType.id === this.$route.query.Type) {
          this.stat_type_selected = statType
        }
      })

      if (this.$route.query.OrebShotType) {
        this.oreb_missed_shot_type_dropdown.data.forEach((shotType) => {
          if (shotType.id === this.$route.query.OrebShotType) {
            this.oreb_missed_shot_type_selected = shotType
          }
        })
      }

      if (this.$route.query.SecondsSinceOrebLte) {
        this.seconds_since_oreb_lte = this.$route.query.SecondsSinceOrebLte
      }
      if (this.$route.query.SecondsSinceOrebGte) {
        this.seconds_since_oreb_gte = this.$route.query.SecondsSinceOrebGte
      }

      if (this.stat_type_selected.id !== 'KobeAssist') {
        if (this.$route.query.FromMargin) {
          this.margin_from = this.$route.query.FromMargin
        }
        if (this.$route.query.ToMargin) {
          this.margin_to = this.$route.query.ToMargin
        }
        if (this.$route.query.FromTime) {
          this.possession_start_time_from = this.$route.query.FromTime
        }
        if (this.$route.query.ToTime) {
          this.possession_start_time_to = this.$route.query.ToTime
        }
        if (this.$route.query.PeriodGte) {
          this.period_gte = this.$route.query.PeriodGte
        }
        if (this.$route.query.PeriodLte) {
          this.period_lte = this.$route.query.PeriodLte
        }
        if (this.$route.query.PeriodEquals) {
          this.period_lte = this.$route.query.PeriodEquals
          this.period_gte = this.$route.query.PeriodEquals
        }
        if (this.$route.query.ShotTimeGte) {
          this.shot_time_gte = this.$route.query.ShotTimeGte
        }
        if (this.$route.query.ShotTimeLte) {
          this.shot_time_lte = this.$route.query.ShotTimeLte
        }
        if (this.$route.query.ShotDistanceGte) {
          this.shot_distance_gte = this.$route.query.ShotDistanceGte
        }
        if (this.$route.query.ShotDistanceLte) {
          this.shot_distance_lte = this.$route.query.ShotDistanceLte
        }
        if (this.$route.query.SecondsSincePossessionStartGte) {
          this.seconds_since_possession_start_gte = this.$route.query.SecondsSincePossessionStartGte
        }
        if (this.$route.query.SecondsSincePossessionStartLte) {
          this.seconds_since_possession_start_lte = this.$route.query.SecondsSincePossessionStartLte
        }
        if (this.$route.query.OffOwnDreb && this.$route.query.OffOwnDreb.toLowerCase() === 'true' && this.stat_type_selected.id === 'Player') {
          this.off_own_dreb = true
        }
        if (this.$route.query.OffOwnOreb && this.$route.query.OffOwnOreb.toLowerCase() === 'true' && this.stat_type_selected.id === 'Player') {
          this.off_own_oreb = true
        }
        if (this.$route.query.OffOwnMiss && this.$route.query.OffOwnMiss.toLowerCase() === 'true' && this.stat_type_selected.id === 'Player') {
          this.off_own_miss = true
        }
      }

      if (this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.Type) {
        this.getStats()
      }
    },
    loadData () {
      this.getDropdown([this.setSeasonDropdown, this.setSeasonTypeDropdown, this.setDropdown])
    },
    updateData () {
      if (this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.Type) {
        this.getStats()
      } else {
        this.loadData()
      }
    },

    changeStats () {
      this.query_params = {}
      this.season_selected_string = this.getSeasonsSelectedString()

      this.query_params[this.$seasonParam] = this.season_selected_string
      this.query_params[this.$seasonTypeParam] = this.season_type_selected.id

      if (this.stat_type_selected) {
        this.query_params[this.$typeParam] = this.stat_type_selected.id
      }
      if (this.oreb_missed_shot_type_selected && this.oreb_missed_shot_type_selected.id !== '') {
        this.query_params[this.$orebShotTypeParam] = this.oreb_missed_shot_type_selected.id
      }
      if (this.seconds_since_oreb_lte && this.seconds_since_oreb_lte !== '') {
        this.query_params[this.$secondsSinceOrebLteParam] = this.seconds_since_oreb_lte
      }
      if (this.seconds_since_oreb_gte && this.seconds_since_oreb_gte !== '') {
        this.query_params[this.$secondsSinceOrebGteParam] = this.seconds_since_oreb_gte
      }
      if (this.stat_type_selected && this.stat_type_selected.id !== 'KobeAssist') {
        if (!this.possession_start_selected) {
          this.possession_start_selected = this.possession_start_dropdown.data[0]
        }
        this.query_params[this.$startTypeParam] = this.possession_start_selected.id

        if (this.margin_from && this.margin_from !== '') {
          this.query_params[this.$fromMarginParam] = this.margin_from
        }
        if (this.margin_to && this.margin_to !== '') {
          this.query_params[this.$toMarginParam] = this.margin_to
        }
        if (this.period_lte && this.period_lte !== '' && this.period_lte !== this.period_gte) {
          this.query_params[this.$periodLteParam] = this.period_lte
        }
        if (this.period_gte && this.period_gte !== '' && this.period_lte !== this.period_gte) {
          this.query_params[this.$periodGteParam] = this.period_gte
        }
        if (this.period_gte && this.period_lte && this.period_gte !== '' && this.period_lte === this.period_gte) {
          this.query_params[this.$periodEqualsParam] = this.period_gte
        }
        if (this.possession_start_time_from && this.possession_start_time_from !== '') {
          this.query_params[this.$fromTimeParam] = this.possession_start_time_from
        }
        if (this.possession_start_time_to && this.possession_start_time_to !== '') {
          this.query_params[this.$toTimeParam] = this.possession_start_time_to
        }
        if (this.shot_time_lte && this.shot_time_lte !== '') {
          this.query_params[this.$shotTimeLteParam] = this.shot_time_lte
        }
        if (this.shot_time_gte && this.shot_time_gte !== '') {
          this.query_params[this.$shotTimeGteParam] = this.shot_time_gte
        }
        if (this.shot_distance_lte && this.shot_distance_lte !== '') {
          this.query_params[this.$shotDistanceLteParam] = this.shot_distance_lte
        }
        if (this.shot_distance_gte && this.shot_distance_gte !== '') {
          this.query_params[this.$shotDistanceGteParam] = this.shot_distance_gte
        }
        if (this.seconds_since_possession_start_lte && this.seconds_since_possession_start_lte !== '') {
          this.query_params[this.$secondsSincePossessionStartLteParam] = this.seconds_since_possession_start_lte
        }
        if (this.seconds_since_possession_start_gte && this.seconds_since_possession_start_gte !== '') {
          this.query_params[this.$secondsSincePossessionStartGteParam] = this.seconds_since_possession_start_gte
        }
        if (this.off_own_dreb && this.stat_type_selected.id === 'Player') {
          this.query_params[this.$offOwnDrebParam] = this.off_own_dreb
        }
        if (this.off_own_oreb && this.stat_type_selected.id === 'Player') {
          this.query_params[this.$offOwnOrebParam] = this.off_own_oreb
        }
        if (this.off_own_miss && this.stat_type_selected.id === 'Player') {
          this.query_params[this.$offOwnMissParam] = this.off_own_miss
        }
      }

      this.$router.push({name: 'shot_query_summary', query: this.query_params})
    },
    getStats () {
      this.show_error_message = false
      this.loading = true
      this.table_data = []

      axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
        params: this.$route.query
      })
        .then((response) => {
          if (!response.data.error) {
            this.table_data = response.data.results
          } else {
            this.show_error_message = true
          }
          this.loading = false
        }, (error) => {
          this.show_error_message = true
          this.loading = false
          this.error = error
        })
    }
  }
}
</script>

<style scoped>
@import "https://maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css"

</style>



// WEBPACK FOOTER //
// src/components/ShotQuerySummary.vue